/**
 * HomeWhatWeDo — services, not product features.
 *
 * Positioned as what the company builds for a client, so each card is a
 * capability we can deliver rather than a checkbox in one fixed product.
 * Icon + heading + one sentence: enough to scan, no fixed pricing implied.
 */
import { motion } from "framer-motion";
import {
  Smartphone,
  Globe,
  ShoppingCart,
  Building2,
  Wallet,
  LayoutDashboard,
  Wrench,
  Server,
} from "lucide-react";

const services = [
  {
    icon: Smartphone,
    title: "App Mobile ah",
    body: "Android iyo iOS labadaba — app magacaaga sita oo Play Store iyo App Store la geeyo.",
  },
  {
    icon: Globe,
    title: "Website & Nidaam",
    body: "Website casri ah iyo nidaam maamul oo ku habboon habka aad u shaqeyso.",
  },
  {
    icon: ShoppingCart,
    title: "E-commerce",
    body: "Dukaan online ah oo leh alaab, dalab iyo gaadiid — Soomaaliya iyo dibaddaba.",
  },
  {
    icon: Building2,
    title: "Suuq & Guri-raadin",
    body: "Nidaam liiskeed leh — guryo, kiro ama alaab la raadiyo, la shaandheeyo lana xiriiro.",
  },
  {
    icon: Wallet,
    title: "Lacag Mobile ah",
    body: "EVC Plus, Zaad, eDahab iyo Jeeb — lacagta si toos ah ayaa loo xaqiijiyaa.",
  },
  {
    icon: LayoutDashboard,
    title: "Dashboard & Warbixin",
    body: "Iibka, faa'iidada iyo kaydka meel keliya kaga eeg, warbixinna ka soo saar.",
  },
  {
    icon: Wrench,
    title: "Nidaam Gaar ah",
    body: "Waxbarasho, caafimaad ama xisaabaad — haddii aan jirin, cusub ayaan kaaga dhisaynaa.",
  },
  {
    icon: Server,
    title: "Hosting & Taageero",
    body: "Server, domain iyo ilaalin, iyo taageero joogto ah kadib markaan dhisno.",
  },
];

function Card({ item, index }) {
  const Icon = item.icon;
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.4, delay: (index % 4) * 0.06 }}
      className="group h-full p-6 transition-all duration-300 hover:-translate-y-1"
      style={{
        background: "var(--bg-card)",
        border: "1px solid var(--border)",
        borderRadius: "var(--radius-lg)",
        boxShadow: "var(--shadow-card)",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.boxShadow = "var(--shadow-card-hover)")}
      onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "var(--shadow-card)")}
    >
      <span
        className="mb-4 inline-flex h-11 w-11 items-center justify-center"
        style={{ background: "var(--icon-bg)", borderRadius: "var(--radius-md)" }}
      >
        <Icon
          className="h-5 w-5 text-navy transition-colors duration-300 group-hover:text-accent"
          strokeWidth={1.75}
        />
      </span>
      <h3 className="font-heading text-base font-bold text-navy">{item.title}</h3>
      <p className="mt-2 text-sm leading-relaxed" style={{ color: "var(--text-muted)" }}>
        {item.body}
      </p>
    </motion.div>
  );
}

export default function HomeWhatWeDo() {
  return (
    <section id="features" className="py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-6">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.4 }}
          className="mx-auto max-w-2xl text-center"
        >
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-muted">
            Waxaan qabno
          </span>
          <h2
            className="font-heading mt-4 text-navy"
            style={{ fontSize: "clamp(1.5rem, 2.8vw, 2rem)", fontWeight: 800, letterSpacing: "-0.03em" }}
          >
            Waxaan dhisnaa wixii ganacsigaagu u baahan yahay
          </h2>
          <p className="mt-4 text-base" style={{ color: "var(--text-muted)" }}>
            Mid kasta oo ka mid ah kuwan waxaan u habaynaa si waafaqsan baahidaada.
          </p>
        </motion.div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {services.map((item, i) => (
            <Card key={item.title} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
